import { Box, Text } from '@bechtel/gds';
import { MetadataTable } from '@bechtel/sr-types';
import { FC } from 'react';
import { useLanguage } from '~/components/molecules';
import { MultiLingualText } from '../multi-lingual-text';
import { LineStyled } from './styled';

interface FormSectionHeadingProps {
  heading?: string;
  tableMetadata?: MetadataTable | null;
  lineWidth?: string;
}

export const FormSectionHeading: FC<FormSectionHeadingProps> = ({ heading, tableMetadata, lineWidth }) => {
  const { isAlternateLanguageUsed } = useLanguage();
  return (
    <>
      <Box>
        {tableMetadata ? (
          <Text color="grey.800" size="400" weight="600">
            {isAlternateLanguageUsed ? tableMetadata?.alternateDescription : tableMetadata?.description}
          </Text>
        ) : (
          <MultiLingualText color="grey.800" size="400" weight="600">
            {heading ? heading : ''}
          </MultiLingualText>
        )}
      </Box>
      <LineStyled style={{ width: lineWidth ? lineWidth : '100%' }} />
    </>
  );
};
